import React from "react";
import * as style from "../style/basic.style";

export const LandingHeader = () => {
  return (
    <style.Header>
      <img src={process.env.PUBLIC_URL + "/image/Group 61.png"} />
    </style.Header>
  );
};
